/* eslint-disable no-debugger*/
import {useState, useEffect, useRef} from "react";
import {Link, useNavigate} from "react-router-dom";
import {ModifiedToast} from "./toaster";
import {Helmet, HelmetProvider} from "react-helmet-async";
import {useSendOtpMutation, useSignupUserMutation, useVerifyUserMutation} from "../services/authApi";
import {FormInput} from "./formInput";

import { ToastContainer, toast } from "react-toastify";
import {useDispatch} from "react-redux";
import {
  emailValidator,
  passwordValidator,
  nameValidator
} from "../pages/settings/validation";
import { userInfo } from "../redux/AuthSlice/authSlice";
import { openJoyce } from "../redux/JoyiceSlice/joyiceSlice";


const SignUp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [ formData, setFormData ] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    mobileNo: "",
    countryCode: "+91",
    otp:"",
    otpId:"",
    confirmPassword: "",
    checkbox:false
  });

  useEffect(() => {
    setFormData({...formData, countryCode: '+91'});
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      navigate('/dashboard');
    }
  }, []);

  const [ error, setError ] = useState({
    firstNameError: "",
    lastNameError: "",
    emailError: "",
    passwordError: "",
    mobileNoError: "",
    confirmPasswordError:"",
    checkboxError:""
  });

  const [ { data,
     isLoading, isError, isSuccess, error:apiError
     } ] =
    useSignupUserMutation();
    const [ sendOtp, {data:otpData, isSuccess:isOtpSuccess } ] = useSendOtpMutation();
    const [ verifyUser, {isSuccess: isUserVerified, isError: isVerifiedError, error: verifiedError } ] = useVerifyUserMutation();
    const toastId = useRef(null);
    useEffect(() => {
      if (isLoading) {
        toastId.current = toast.loading("Please wait...", {
        position: "top-right",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        theme: "colored",
        type: "info"
      });
      }
      if (isSuccess) {
        toast.update(
          toastId.current,
          ("Your account has been created successfully.",
          {
            render: "Your account has been created successfully.",
            type: "success",
            autoClose: 2000,
            isLoading: false
          })
        );
        localStorage.setItem('accessToken', data.accessToken);
        localStorage.setItem("loggedInUser", JSON.stringify(data.data));
        dispatch(openJoyce({isJoyce:true, isSignup:true, data:data}));
        dispatch(userInfo(data));
        window.location.href = "/dashboard";
      }
      if (isError){
        const toastMessage = apiError?.data?.message
          ? apiError?.data?.message
          : "Something went wrong";
        toast.update(
          toastId.current,
          (toastMessage,
          {
            render: toastMessage,
            type: "error",
            autoClose: 4000,
            isLoading: false
          })
        );    
        
      }
    }, [ isSuccess, isError, isLoading ]);
    useEffect(() => {
      if(isUserVerified){
        let value = {
          "mobile": `${formData.mobileNo}`,
          "country_code": `${formData.countryCode}`,
          "email":`${ formData.email}`
        };
        sendOtp(value);  
      }
      if(isVerifiedError){
        const toastMessage = verifiedError?.data?.message
        ? verifiedError?.data?.message
        : "Something went wrong";
      toast.error(toastMessage,
        {
          render: toastMessage,
          type: "error",
          autoClose: 4000,
          isLoading: false
        }
      ); 
      }
    }, [ isUserVerified, isVerifiedError ]);
  useEffect(() => {
    if (isOtpSuccess) {
      setFormData({...formData, otpId: otpData?.data?.id});
      setTimeout(() => {
        localStorage.setItem('otp_data', JSON.stringify(otpData))
        localStorage.setItem('registration_data', JSON.stringify(formData))
        navigate('/otp-verification');
      }, 1000);
      
    }
  }, [ isOtpSuccess ]);

  const handlerChange = (e) => {
    const {name} = e.target;
    if (name === "firstName") {
      let firstName = nameValidator(name, e.target.value);
      setError({...setError, firstNameError: firstName});
    } else if (name === "lastName") {
      let lastName = nameValidator(name, e.target.value);
      setError({...setError, lastNameError: lastName});
    } else if (name === "email") {
      let email = emailValidator(e.target.value);
      setError({...setError, emailError: email});
    } else if (name === "password") {
      let password = passwordValidator(e.target.value);
      setError({...setError, passwordError: password});

    }else if(name === "confirmPassword"){
   
      if(e.target.value !== formData.password){
        setError({...setError, confirmPasswordError: "Confirm Password must be same as the password"});
      }else{
        setError({...setError, confirmPasswordError: ""});
      }
    }
    setFormData({...formData, [name]: e.target.value});
   
  };

  const onChangeMobile = (e) => {
    const phoneRegex = /^[0-9]{10}$/;
    if(phoneRegex.test(e.target.value)) {
    setFormData({...formData, mobileNo: e.target.value});
    setError({...setError, mobileNoError: ""});
    }else{
      setError({...setError, mobileNoError: "Please Enter a valid mobile number"});
    }
  };

  const handelCheckbox = () => {
    setFormData({...formData, checkbox: !formData.checkbox });
  };

const handelCountryCode = (e) => {
  const codeRegex = /^\+[0-9]{1,3}$/;
  let isCode =codeRegex.test(e.target.value);
  if(isCode) {
    setFormData({...formData, countryCode: e.target.value});
    setError({...setError, mobileNoError: ""});
    }else{
      setError({...setError, mobileNoError: "Please Enter a valid Country Code"});
    }
};

  const [ passwordShown, setPasswordShown ] = useState(false);
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const validaForm = () => {
    const {firstName, lastName, mobileNo, email, password, confirmPassword, countryCode, checkbox} =
      formData;
    let formIsValid = true;
    if (firstName === "") {
      setError((errorValue) => {
        return {
          ...errorValue,
          firstNameError: "Please enter the first name "
        };
      });
      formIsValid = false;
    }
    if (lastName === "") {
      setError((errorValue) => {
        return {
          ...errorValue,
          lastNameError: "Please Enter the last name "
        };
      });
      formIsValid = false;
    }
    if (email === "") {
      setError((errorValue) => {
        return {
          ...errorValue,
          emailError: "Please enter Email"
        };
      });
      formIsValid = false;
    }
    if (password === "") {
      setError((errorValue) => {
        return {
          ...errorValue,
          passwordError: "Please enter password"
        };
      });
      formIsValid = false;
    }
    if (confirmPassword === "") {
      setError((errorValue) => {
        return {
          ...errorValue,
          confirmPasswordError: "Please enter your password"
        };
      });
      formIsValid = false;
    }
    if (countryCode === "") {
      setError((errorValue) => {
        return {
          ...errorValue,
          mobileNoError: "Please enter Country Code"
        };
      });
      formIsValid = false;
    }
    if (mobileNo === "") {
      setError((errorValue) => {
        return {
          ...errorValue,
          mobileNoError: "Please enter Mobile Number"
        };
      });
      formIsValid = false;
    }
    if(!checkbox){
      setError((errorValue) => {
        return {...errorValue, checkboxError:"You must agree to the terms and conditions"};
    });
      formIsValid=false;
    }     
    return formIsValid;
  };
  const handleFormSubmit = (e) => {
    e.preventDefault();
   
    if (validaForm()) {
      verifyUser({email:formData?.email, mobileNo: formData?.mobileNo});
    }
  };

  return (
    <div className=" h-screen	flex bg-gray-bg1 w-full">
      <HelmetProvider>
        <Helmet>
          <title>Simplyenglish AI | Signup </title>
        </Helmet>
      </HelmetProvider>
      <ToastContainer />
      <ModifiedToast />
      <div className=" flex align-center w-full signupPage">
        <div className=" w-full bg-white ">
          <div className="md:flex align-center justify-between h-full items-center flex-wrap md:flex-nowrap     ">
            <div className=" md:p-8 p-2 md:w-1/2 w-full relative">
              <div className=" pt-0">
                <div className="w-full max-w-lg m-auto bg-white lg:p-8 py-5 p-4 pt-3 border shadow-lg rounded-lg ">
                  <div className="text-center w-full MobileLoginImage">
                    <img
                      src="./images/logo.png"
                      width="270"
                      className="mx-auto"
                    />
                  </div>
                  <h1 className="text-xl font-semibold mb-3 text-center">
                    Sign up to your account
                  </h1>
                  <div
                    className="text-left"
                    id="signupForm"
                  >
                    <div className="flex flex-wrap">
                      <div className="w-full lg:w-1/2 lg:pr-4">
                        <div className="parentGroup mb-2">
                          <label htmlFor="email" className="formBlock">
                            First Name
                          </label>
                          <FormInput
                            inputType="text"
                            inputName="firstName"
                            inputID="FirstName"
                            value={formData.firstName}
                            handlerChange={handlerChange}
                          />
                          <div className="help-block text-red-700">
                            {error.firstNameError ? error.firstNameError : ""}
                          </div>
                        </div>
                      </div>
                      <div className="w-full lg:w-1/2 pr-0">
                        <div className="parentGroup mb-2">
                          <label htmlFor="email" className="formBlock">
                            Last Name
                          </label>
                          <FormInput
                            inputType="text"
                            inputName="lastName"
                            inputID="LastName"
                            value={formData.lastName}
                            handlerChange={handlerChange}
                          />
                          <div className="help-block text-red-700">
                            {error.lastNameError ? error.lastNameError : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-wrap">
                      <div className="w-full  mb-2">
                        <label htmlFor="email" className="formBlock">
                          Email
                        </label>
                        <FormInput
                          inputType="text"
                          inputName="email"
                          inputID="email"
                          value={formData.email}
                          handlerChange={handlerChange}
                        />
                        <div className="help-block text-red-700">
                          {error.emailError ? error.emailError : ""}
                        </div>
                      </div>
                      <div className="w-full mb-2">
                        <label htmlFor="email" className="formBlock">
                          Mobile Number
                        </label>
                        <div className="flex items-center">
                          <input
                            type="text"
                            name="countryCode"
                            value={formData.countryCode}
                            onChange={(e) => handelCountryCode(e)}
                            className="appearance-none w-20 bg-gray-100 border rounded text-gray-700 py-2 px-3 focus:outline-none focus:border-gray-500"
                            placeholder="+91"
                          />
                          <input
                            type="text"
                            name="mobileNo"
                            onChange={(e) => onChangeMobile(e)}
                            className="formControl flex-1 ml-2"
                            placeholder="Phone Number"
                          />
                        </div>
                          <div className="help-block text-red-700">
                          {error.mobileNoError ? error.mobileNoError : ""}
                        </div>
                      </div>

                   
                    </div>
                    
                    <div className="flex flex-wrap mb-2">
                      <div className="w-full lg:w-1/2 lg:pr-4 ">
                        <div className="parentGroup mb-2 eyeIcon">
                          <label htmlFor="email" className="formBlock">
                            Password
                          </label>
                          <FormInput
                            inputType={passwordShown ? "text" : "password"}
                            inputName="password"
                            inputID="password"
                            value={formData.password}
                            handlerChange={handlerChange}
                          />
                          <i
                            className={
                              passwordShown
                                ? "fa fa-eye cursor-pointer"
                                : "fa fa-eye-slash cursor-pointer"
                            }
                            onClick={togglePasswordVisiblity}
                          />
                        </div>
                        <div className="help-block text-red-700">
                            {error.passwordError ? error.passwordError : ""}
                          </div>
                      </div>
                      <div className="w-full lg:w-1/2 pr-0 ">
                        <div className="parentGroup mb-1 eyeIcon">
                          <label htmlFor="email" className="formBlock">
                            Confirm Password
                          </label>
                          <FormInput
                            inputType={passwordShown ? "text" : "confirmPassword"}
                            inputName="confirmPassword"
                            inputID="confirmPassword"
                            value={formData.confirmPassword}
                            handlerChange={handlerChange}
                          />
                          <i
                            className={
                              passwordShown
                                ? "fa fa-eye cursor-pointer"
                                : "fa fa-eye-slash cursor-pointer"
                            }
                            onClick={togglePasswordVisiblity}
                          />
                          
                        </div>
                        <div className="help-block text-red-700">
                            {error.confirmPasswordError ? error.confirmPasswordError : ""}
                          </div>
                      </div>
                    </div>
                    <div className="form-group mb-4 ">
                      <label className="formBlock flex  ">
                        <input type="checkbox" checked={formData?.checkbox} className="mr-2 w-5 h-5" onChange={() => handelCheckbox()}/>
                        I agree with{" "}
                        <Link to="/terms-conditions" className="px-1">
                        Terms
                        </Link>{" "}
                        and{" "}
                        <Link to="/terms-conditions" className="pl-1">
                        Conditions
                        </Link>
                      </label>
                    </div>
                    <div className="help-block text-red-700">
                          {error.checkboxError ? error.checkboxError : ""}
                        </div>
                    <div className=" mt-6 text-center">
                    <button
                            className={` mb-4 btn save w-full focus:outline-none focus:border-purple `}
                            aria-describedby="popup-8"
                            onClick={(e) => handleFormSubmit(e)}
                          >
                            Sign up
                          </button>
        
                      <p className="text-gray-600 font-medium">
                        Already have an Account?{" "}
                        <Link to="/" className="primary-text font-semibold">
                          Log in
                        </Link>
                      </p>
                    </div>
                    <ModifiedToast />
                  </div>
                </div>
              </div>
            </div>
            <div className=" md:w-1/2 md:h-full flex flex-wrap  md:flex hidden  justify-center relative ">
              <div className="loginImage bg-white w-full">
                <div className="text-center w-full  px-12 mb-6 mt-2 ">
                  <img
                    src="./images/logo.png"
                    width="270"
                    className="mx-auto mb-4"
                  />
                </div>
                <img src="./images/login.jpg" className="userImage" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
